import { connect } from 'react-redux'

import HistoryTable from '../components/HistoryTable'
import { RootState } from '../types'
import { TradeCommandType } from '@bdswiss/mt4-connector'
import { TradingAction } from '../actions'
import { setTradingSymbol } from '../actions/commonActions'
import { getClosedPositions } from '../actions/GraphQLActions'
import { updateFavourites } from '../actions/GraphQLActions'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    assets: mt4.assets, // rootState.symbolsSubscriptions,
    history: rootState.history,
    currency: state.currency,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    favourites: rootState.favourites,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onGetClosedPositions: (limit: number) => dispatch(getClosedPositions(limit)),
    onShowChart: (symbol: string, tradeType: TradeCommandType) =>
      dispatch(setTradingSymbol(symbol, tradeType)),
    onToggleFavourite: (favourites: string[]) => dispatch(updateFavourites(favourites)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoryTable)
